import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=7ded7d5f"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ded7d5f')) {
      api.createRecord('7ded7d5f', component.options)
    } else {
      api.reload('7ded7d5f', component.options)
    }
    module.hot.accept("./Show.vue?vue&type=template&id=7ded7d5f", function () {
      api.rerender('7ded7d5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/avatar/Show.vue"
export default component.exports